module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg_ii.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "poemt"
  }, [_c('i', [_vm._v("What My Last Man Did")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Andrea Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('i', [_vm._v("Girl with Death Mask")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Jennifer Givhan")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('i', [_vm._v("Fierce Pretty Things")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Tom Howard")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('i', [_vm._v("The Artstars")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Anne Elliott")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466cde58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm01.vue
// module id = 60
// module chunks = 0